import React from 'react';
import Stack from '@mui/material/Stack';
import "../../styles/vehicle/vehicleHeader.css"

export let VehicleHeader = function({tenantId}) {
    return (
        <Stack direction="row" alignItems="center" justifyContent="flex-end" className="header">
            <div className="logoBox">
                <img src={`https://filesapi.sam-performance.com/public/${tenantId}/appsettings/logo.png`} />
            </div>
        </Stack>
    );
};